import { z } from 'zod'

export const changePasswordValidation = z.object({
  currentPassword: z.string().min(8, 'Password must be at least 8 characters long'),
  newPassword: z.string().min(8, 'Password must be at least 8 characters long'),
})

export type ChangePasswordValidation = z.infer<typeof changePasswordValidation>
